import { configureStore, applyMiddleware } from "@reduxjs/toolkit";
import logger from "redux-logger";
import thunk from "redux-thunk";
import { combineReducers } from "redux";

import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";


import canvasSlice from "../containers/Canvas/canvasSlice";
// import loginReducer from "../containers/Login/loginSlice";

const middlewares = applyMiddleware(thunk, logger);

const reducers = combineReducers({
  // loginReducer: loginReducer,
  canvas: canvasSlice
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore(
  {
    reducer: persistedReducer,
    devTools: true,
  },
  middlewares
);

export default store;
